import { Box, TextField, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectChassisLoads } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { ChasisLoad } from "../../../types";
import {
  CHASSIS_LOAD_ROWS,
  CHASSIS_LOADS_COLUMNS,
  CHASSIS_LOADS_SECTION_TITLE,
} from "../data";
import { useStyles } from "./styles";

const ChassisLoadsPanel = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const chassisLoads = useSelector(selectChassisLoads);
  const styles = useStyles();
  const isEnglish = !(i18n.language || "").startsWith("he");

  if (!chassisLoads) {
    return null;
  }

  const updateValue = (key: ChasisLoad, value: string) =>
    dispatch(actions.updateChassisLoadValue({ key, value }));

  return (
    <Box className={styles.panelSection}>
      <Typography className={styles.panelSectionTitle}>
        {t(CHASSIS_LOADS_SECTION_TITLE)}
      </Typography>

      <Box className={styles.chassisTable}>
        {CHASSIS_LOAD_ROWS.map((row) => (
          <Box key={row.key} className={styles.chassisDataRow}>
            <Box className={styles.chassisFieldCell}>
              <Typography className={styles.chassisFieldLabel}>
                {t(CHASSIS_LOADS_COLUMNS.symbol)}
              </Typography>
              <Typography className={styles.chassisSymbolValue}>{row.symbol}</Typography>
            </Box>
            <Box className={styles.chassisFieldCell}>
              <Typography className={styles.chassisFieldLabel}>
                {t(CHASSIS_LOADS_COLUMNS.description)}
              </Typography>
              <Typography className={styles.chassisDescriptionValue}>
                {t(row.descriptionKey)}
              </Typography>
            </Box>
            <Box className={styles.chassisInputGroup}>
              <Box
                className={styles.chassisInputFieldCell}
                style={isEnglish ? { width: "auto", minWidth: "auto" } : {}}
              >
                <Typography
                  className={styles.chassisFieldLabel}
                  style={isEnglish ? { whiteSpace: "nowrap" } : {}}
                >
                  {t(CHASSIS_LOADS_COLUMNS.value)}
                </Typography>
                <TextField
                  className={styles.chassisValueInput}
                  variant="outlined"
                  value={chassisLoads[row.key].value}
                  onChange={(event) => updateValue(row.key, event.target.value)}
                />
              </Box>
              <Box
                className={styles.chassisInputFieldCell}
                style={isEnglish ? { width: "auto", minWidth: "auto" } : {}}
              >
                <Typography
                  className={styles.chassisFieldLabel}
                  style={isEnglish ? { whiteSpace: "nowrap" } : {}}
                >
                  {t(CHASSIS_LOADS_COLUMNS.calculation)}
                </Typography>
                <Box className={styles.chassisCalculationValue}>
                  {chassisLoads[row.key].calculationValue}
                </Box>
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ChassisLoadsPanel;
